import { createNumberedIcon, icon_sizes, icon_sizes_x, icon_types } from '@c/Catalog/Map/mapStyler'
import { FaLocationArrow, FaLocationCrosshairs } from 'react-icons/fa6'

export const ORANGE_CATEGORIES = new Set(['CAFE', 'ICE-CR', 'REST', 'BAR', 'TERR'])

type CreateMarkerIconParams = {
  id: string | null
  window: any
  idx: number | null
  rank: number
  category: string
  zoom?: number
  heading?: number | null
  isHighlighted: boolean
  selectedPoint: string
  iconUsing: 'main' | 'route'
}

export function createMarkerIcon(params: CreateMarkerIconParams) {
  const {
    id,
    window,
    idx,
    zoom = 13,
    category,
    rank,
    heading,
    isHighlighted,
    selectedPoint,
    iconUsing,
  } = params

  const zIndex = rank
  const isRouteWindow = iconUsing === 'route'

  if (category !== 'user-current-location') {
    if (idx !== null) {
      const icon_file = createNumberedIcon(idx + 1, isHighlighted)

      return {
        url: icon_file,
        scaledSize: new window.google.maps.Size(32, 32),
        anchor: new window.google.maps.Point(16, 16),
        zindex: isRouteWindow ? 1000 - idx : 1000,
      }
    }

    let icon_file = icon_types.get(category) ?? '/img/new/star.png'

    if (selectedPoint === id) {
      if (ORANGE_CATEGORIES.has(category)) {
        icon_file = '/img/new/base-selected_orange.png'
      } else {
        icon_file = '/img/new/base-selected.png'
      }
    }
    const icn_sizes = getIconSizesByZoom(zoom)

    let size_pix = icn_sizes.get(rank) ?? 12
    let size_piy = 57

    if (rank === 0) {
      size_pix = zoom >= 16 ? 36 : 14
    }

    if (size_pix === 18) size_piy = 22
    if (size_pix === 24) size_piy = 29
    if (size_pix === 32) size_piy = 38

    if (size_pix < 18) {
      size_piy = Math.round((size_pix / 18) * 22)
    }

    if (rank === 0 && size_pix > 18) {
      size_piy = Math.round((size_pix / 48) * 57)
    }

    if (size_pix <= 18 && !ORANGE_CATEGORIES.has(category) && rank !== 0 && rank !== 3) {
      icon_file = '/img/new/smal.png'
      size_pix = 16
    }

    return {
      url: icon_file,
      scaledSize: new window.google.maps.Size(size_pix, size_piy), // Adjust the size as needed
      zindex: isHighlighted ? 1000 : zIndex,
    }
  }

  if (idx !== null) {
    const icon_file = createNumberedIcon(idx + 1, isHighlighted)

    return {
      url: icon_file,
      scaledSize: new window.google.maps.Size(32, 32),
      anchor: new window.google.maps.Point(16, 16),
      zindex: 1000,
    }
  }

  const currentPositionIconPath = heading
    ? FaLocationArrow({}).props.children[0].props.d
    : FaLocationCrosshairs({}).props.children[0].props.d

  return {
    path: currentPositionIconPath,
    anchor: new window.google.maps.Point(256, 256),
    strokeColor: '#c04b35',
    fillColor: '#FF7012',
    fillOpacity: 1,
    strokeWeight: 0,
    scale: 0.065,
    ...(heading && { rotation: -45 + (heading || 0) }),
    zindex: 0,
  }
}

function getIconSizesByZoom(zoom: number): Map<number, number> {
  if (zoom >= 20) {
    return icon_sizes_x.get(19) ?? icon_sizes
  }

  return icon_sizes_x.get(zoom) ?? icon_sizes
}
